export default __webpack_public_path__ + "static/media/Mail-white.061e4c87.svg";